export default "__VITE_ASSET__CLdFpSVz__"